import React from "react";
import { Link } from "react-router-dom";

import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";

import ProvidersIcon from "../../assets/icons/group.svg";
import RequestDocumentsIcon from "../../assets/icons/difference.svg";
import PropertiesIconSVG from "../common/customSVGs/PropertiesIconSVG";
import { countyRecorderMenuItems } from "./countyRecorderAccess";

const ICONS = {
  Dashboard: <PropertiesIconSVG />,
  "C.A.R. Dashboard": (
    <InsightsOutlinedIcon className="icon_width" sx={{ color: "#b1c7b9" }} />
  ),
  "C.A.R. Agents": (
    <BadgeOutlinedIcon className="icon_width" sx={{ color: "#b1c7b9" }} />
  ),
  Users: <img src={ProvidersIcon} alt="" className="icon_width" />,
  "Risk Assessments": (
    <PollOutlinedIcon className="icon_width" sx={{ color: "#b1c7b9" }} />
  ),
  "Customer Service Queue": (
    <img src={RequestDocumentsIcon} alt="" className="icon_width" />
  ),
  "EP Outreach": (
    <CampaignOutlinedIcon className="icon_width" sx={{ color: "#b1c7b9" }} />
  ),
};

const CountyRecorderMenu = ({
  open = true,
  onNavigate = () => {},
  isCarPartner = undefined,
}) => {
  return (
    <>
      {countyRecorderMenuItems(isCarPartner).map((item) => {
        const pathActive =
          item.to === "/customer-service-queue"
            ? window.location.pathname.includes("customer-service-queue")
            : window.location.pathname.includes(item.to);

        return (
          <ListItem key={item.to} disablePadding>
            <Link
              className={`text-white text-center text-decoration-none ${
                pathActive ? "active" : ""
              }`}
              onClick={onNavigate}
              to={item.to}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  width: 250,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 1 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {ICONS[item.label]}
                </ListItemIcon>
                <ListItemText
                  className="menu-item"
                  primary={item.label}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </Link>
          </ListItem>
        );
      })}
    </>
  );
};

export default CountyRecorderMenu;
